import { SOCIAL_LINKS } from "@/config/site";

const FOOTER_LINKS = [
  { label: "About", href: "#about" },
  { label: "Presale", href: "#presale" },
  { label: "Tokenomics", href: "#tokenomics" },
  { label: "Utility", href: "#utility" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "Security", href: "#security" },
  { label: "FAQ", href: "#faq" },
  { label: "Whitepaper", href: "#whitepaper" },
];

const SOCIAL_LABELS = {
  twitter: "X / Twitter",
  telegram: "Telegram",
  discord: "Discord",
  github: "GitHub",
};

function scrollTo(e, href) {
  e.preventDefault();
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Footer() {
  const socials = Object.entries(SOCIAL_LINKS).filter(([, url]) => url && url.trim() !== "");

  return (
    <footer className="relative border-t border-white/10 bg-[#050508]" data-testid="footer">
      <div className="mx-auto w-full max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-7 w-7 items-center justify-center rounded-md border border-white/15 bg-gradient-to-br from-indigo-500/30 to-violet-500/20">
                <span className="h-2 w-2 rounded-sm bg-indigo-400" />
              </span>
              <span className="font-display text-sm font-bold uppercase tracking-[0.22em] text-white">
                Xenovia Prime
              </span>
            </div>
            <div className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-indigo-300">XVPR</div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-gray-500">
              A fixed-supply digital asset designed for a growing Web3 ecosystem. Currently in
              presale / pre-launch.
            </p>

            {socials.length > 0 && (
              <div className="mt-6 flex flex-wrap gap-3">
                {socials.map(([key, url]) => (
                  <a
                    key={key}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-full border border-white/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.16em] text-gray-300 transition-colors hover:border-white/40 hover:text-white"
                    data-testid={`footer-social-${key}`}
                  >
                    {SOCIAL_LABELS[key] || key}
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Links */}
          <div className="lg:col-span-4 lg:col-start-9">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-gray-600">Navigate</div>
            <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {FOOTER_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={(e) => scrollTo(e, l.href)}
                  className="font-mono text-[12px] uppercase tracking-[0.12em] text-gray-400 transition-colors hover:text-white"
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Legal disclaimer */}
        <div className="mt-14 rounded-2xl border border-white/8 bg-white/[0.02] p-6 sm:p-7">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-gray-600">Legal Disclaimer</div>
          <p className="mt-3 text-xs leading-relaxed text-gray-500">
            This website is provided for informational purposes only and does not constitute
            financial, investment, legal, tax, accounting or regulatory advice. Digital assets
            involve significant risks, including market volatility, smart-contract vulnerabilities,
            regulatory changes, cybersecurity threats, technological failures and the potential loss
            of digital assets. Nothing on this website guarantees profit, returns, appreciation,
            future value, exchange listings, adoption or investment performance. You are solely
            responsible for evaluating the risks and should conduct your own research and seek
            independent professional advice before participating.
          </p>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/8 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-gray-500">
            © 2026 Xenovia Prime. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-gray-600">
            Presale • Pre-Launch • XVPR
          </p>
        </div>
      </div>
    </footer>
  );
}
